import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { REQUEST_LOADING_STATES } from "../../helpers/constant";
import { IBlog, IBlogState, PageableData } from "../../helpers/types";
import { blogService } from "../../services/blog.service";

const initialState: IBlogState = {
  blogs: [],
  total: 0,
  loading: REQUEST_LOADING_STATES.IDLE,
  error: null,
  hasMore: false,
  currentPage: 1,
  selectedBlog: null,
};

export const getBlogs = createAsyncThunk("blogs/getBlogs", async ({ page, offset, limit }: { page?: number, offset?: number, limit?: number }): Promise<PageableData<IBlog[]>> => {
  return blogService.getBlogs({ offset, limit });
});


export const getBlogDetails = createAsyncThunk("blogs/getBlogDetails", async ({ id }: { id: string }): Promise<IBlog> => {
  return blogService.getBlogDetails({ id });
})

const BlogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBlogs.pending, (state, action) => {
      state.loading = REQUEST_LOADING_STATES.PENDING;
      state.error = null;
      state.currentPage = action?.meta?.arg?.page || 1;
    });
    builder.addCase(getBlogs.fulfilled, (state, action) => {
      const newData = state.currentPage > 1 ? [...state.blogs, ...action.payload.data] : action.payload.data;

      state.blogs = newData as IBlog[];
      state.total = action.payload.total;
      state.hasMore = action.payload.total > newData?.length;
      state.loading = REQUEST_LOADING_STATES.SUCCEEDED;
    });
    builder.addCase(getBlogs.rejected, (state, action) => {
      state.loading = REQUEST_LOADING_STATES.FAILED;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getBlogDetails.pending, (state, action) => {
      state.loading = REQUEST_LOADING_STATES.PENDING;
      state.error = null;
    });
    builder.addCase(getBlogDetails.fulfilled, (state, action) => {
      state.selectedBlog = action.payload as IBlog;
      state.loading = REQUEST_LOADING_STATES.SUCCEEDED;
    });
    builder.addCase(getBlogDetails.rejected, (state, action) => {
      state.loading = REQUEST_LOADING_STATES.FAILED;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default BlogSlice.reducer;
